import React from 'react';
import PropTypes from 'prop-types';

import {injectIntl} from 'react-intl';
import Button from '../button/Button';

@injectIntl
export default class LoadMore extends React.PureComponent {
  static propTypes = {
    wrapperClassName: PropTypes.string,
    navClassName: PropTypes.string,
    itemsProp: PropTypes.string,

    component: PropTypes.func.isRequired,
    onLoadMore: PropTypes.func.isRequired,
    items: PropTypes.array,

    total: PropTypes.number,
    error: PropTypes.bool,
    isLoading: PropTypes.bool
  };

  static defaultProps = {
    wrapperClassName: 'load-more',
    navClassName: 'load-more__nav',
    itemsProp: 'items',
    items: [],
    total: -1
  };

  loadMore = () => {
    const {isLoading, onLoadMore, items, total} = this.props;

    if (isLoading) {
      return;
    }

    if (items && items.length >= total) {
      return;
    }

    onLoadMore();
  };

  render() {
    const {
      intl,
      wrapperClassName, navClassName,
      component: Component, itemsProp,
      items, total, isLoading, error,
      ...rest
    } = this.props;

    const loaded = items ? items.length : 0;

    return (
      <div className={wrapperClassName}>

        <Component {...rest} {...{[itemsProp]: items}}/>

        {(loaded < total || total < 0) && (
          <div className={navClassName}>
            <Button full more loading={isLoading} onClick={this.loadMore}>
              {error ?
                intl.formatMessage({id: 'section.loader.retry'}) :
                intl.formatMessage({id: 'section.loader.show-more'})
              }
              &nbsp;
              {total > 0 && <b>({total - loaded})</b>}
            </Button>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/loadMore/LoadMore.js